import React, { Component } from 'react';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import Ratings from '../../../components_new/common/Ratings';
import Text from '../../../components_new/common/Text';
import Line from '../../../components_new/common/Line';
import ProfileImg from '../../../components_new/common/ProfileImg';


const BlockText = styled(Text)`
  white-space: normal;
`;
const Flag = styled.img`
  cursor: pointer;
`;

export default class extends Component {
  constructor() {
    super();
    this.state = {
      reviewLimit: 4,
    };
  }

  seeMore = () => {
    this.setState(prevState => ({ reviewLimit: prevState.reviewLimit + 4 }));
  }

  seeLess = () => {
    this.setState({ reviewLimit: 4 });
  }

  // 255

  render() {
    const reviews = this.props.reviews.slice(0, this.state.reviewLimit).map((e, i) => (
      <Box key={i} m={24}>
        <Flex justifyContent="space-between" alignItems="end">
          <Flex alignItems="center">
            <ProfileImg
small
              backgroundImg={e.authorData.picture || '/icons/avatar.svg'}
              mx={4}  
            />
            <Box m={3}>
              <Text
                emphasis
                ml={3}
                mb={1}
              >{e.authorData.firstName}</Text>
              <Text text grayDarkMedium ml={3}>{e.createdAt}</Text>
            </Box>
          </Flex>
          <Flag src="/icons/flag.svg" />
        </Flex>
        <Ratings
          small
          rating={e.rating}
          mb={4}
          mt={3}
        />
        <BlockText pagragraph mb={24}>{e.reviewContent}</BlockText>
        <Line color="gray" />
      </Box>
    ));

    return (
      <div>
        { reviews.length ?
          <Flex
alignItems="center"
            pt={4}
            ml={4}
          >
            <Text large light mr={4}>{this.props.reviewsCount} Reviews</Text>
            <Ratings
medium
              rating={this.props.averageRating}  
            />
          </Flex>
          :
          <Text primaryLight p={4}>
            There are no reviews for this item.
          </Text>
        }
        { reviews }
        {
          this.props.reviewsCount >= 4 &&
          (this.state.reviewLimit >= this.props.reviewsCount ?
            <Text
link
            ml={4}
            pb={4}
            onClick={this.seeLess}
          >See less reviews</Text>
          :
          <Text
link
            ml={4}
            pb={4}
            onClick={this.seeMore}
          >See more reviews</Text>)
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/presentation/Details/Reviews.js